/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AddInvalidDataReportInput } from '../models/AddInvalidDataReportInput';
import type { InvalidDataReportDto } from '../models/InvalidDataReportDto';
import type { InvalidDataReportDtoListResult } from '../models/InvalidDataReportDtoListResult';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class InvalidDataReportService {

    /**
     * @param version 
     * @param offset 
     * @returns InvalidDataReportDtoListResult OK
     * @throws ApiError
     */
    public static listInvalidDataReports(
version: string,
offset?: number,
): CancelablePromise<InvalidDataReportDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/InvalidDataReport',
            path: {
                'version': version,
            },
            query: {
                'offset': offset,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns InvalidDataReportDto OK
     * @throws ApiError
     */
    public static addInvalidDataReport(
version: string,
requestBody?: AddInvalidDataReportInput,
): CancelablePromise<InvalidDataReportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/InvalidDataReport',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
